import { MasterVisualizarPerfilComponent } from './../../visualizar-perfil/master-visualizar-perfil.component';
import {
  Component,
  OnInit,
  ViewChild,
  Input,
  EventEmitter,
  AfterViewInit,
  ViewChildren,
  QueryList,
} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { CustomAuthenticationService } from '@app/auth/services/custom-authentication.service';
import { PermissionsType } from '@app/custom-shared/enums/permissions-type.enum';

@Component({
  selector: 'table-profile',
  templateUrl: './table-profile.component.html',
})
export class TableProfile implements OnInit, AfterViewInit {
  profiles: any;
  filterAutoComplete: Array<any>;
  usersComplete: any;
  dialogConfig: any;

  editar: boolean = false;
  isAsc: boolean = false;

  @ViewChildren(MatSort) sort = new QueryList<MatSort>();
  @Input() displayColumns: Array<string>;
  @Input() dataProfiles: Array<any>;
  @Input() filterProfile: EventEmitter<any>;

  profileFilter: any;

  constructor(
    private dialog: MatDialog,
    private customAuthenticationService: CustomAuthenticationService,
  ) {}

  ngOnInit() {
    this.dialogConfig = new MatDialogConfig();

    this.dialogConfig.disableClose = true;
    this.dialogConfig.autoFocus = true;
    this.dialogConfig.hasBackdrop = true;
    this.dialogConfig.height = '90vh';
    this.dialogConfig.width = '92vw';
    this.dialogConfig.maxWidth = '100vw';
    this.getProfiles();

    this.editar = this.customAuthenticationService.hasPermission(
      PermissionsType.editarPerfilDeAcesso,
    );
  }

  ngAfterViewInit(){
    this.profiles.sort = this.sort.toArray()[0];
  }


  getProfiles() {
    this.profiles = new MatTableDataSource<any>(
      this.dataProfiles.naturalSort(['profile']),
    );
    this.profiles.sortingDataAccessor = (data, sortHeaderId) => {
      return typeof data[sortHeaderId] === 'string'
          ? data[sortHeaderId].naturalNormalize() :
          data[sortHeaderId];
    }
    this.profiles.sort = this.sort.toArray()[0];
  }



  openDialogVisualizarPerfil(id) {
    const dialogRef = this.dialog.open(
      MasterVisualizarPerfilComponent,
      this.dialogConfig,
    );
    dialogRef.componentInstance.id = id;
  }
}
